import nicolaLino from '../assets/nicolaLino.png';
import nicolaLogo from '../assets/nicolaLogo.png';
import nicolaLogoLarge from '../assets/nicolaLogoLarge.png';
import nicolaLogoW from '../assets/nicolaLogoW.png';
import image01 from '../assets/1.png';
import image02 from '../assets/2.png';
import image03 from '../assets/3.png';
import image04 from '../assets/4.jpg';

export default {
    nicolaLino,
    nicolaLogo,
    nicolaLogoLarge,
    nicolaLogoW,
    image01,
    image02,
    image03,
    image04
};